import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/dropdown.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import './styles.scss'
import { hot } from 'react-hot-loader'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { ChartInternet } from 'components/chartinternet'
import { ChartDownloadspeed } from 'components/chartdownloadspeed'
import { ChartMusic } from 'components/chartmusic'
import { ChartTelephones } from 'components/charttelephones'
import { ChartTelephoneconnections } from 'components/charttelephoneconnections'
import { ChartStreaming } from 'components/chartstreaming'
import { ChartSocialnetworks } from 'components/chartsocialnetworks'
import { Waypoint } from 'react-waypoint'
import Nouislider from 'nouislider-react'
import 'nouislider/distribute/nouislider.css'
import Typist from 'react-typist'
import renderHTML from 'react-render-html'
import { SectionTitle } from 'components/sectiontitle'
import { DownloadComparison } from 'components/downloadcomparison'
import { StorageEvolution } from 'components/storageevolution'
import AudioPlayer from 'components/audioplayer'
// import uniq from 'lodash/uniq'
import range from 'lodash/range'
import editorContentData from '../../../data/editor.json'
import telefonieUserGroupsData from '../../../data/telefonieUserGroups.json'
import festnetzUserGroupsData from '../../../data/festnetzUserGroups.json'
import internetUserGroupsData from '../../../data/internetusergroups.json'
import musikUserGroupsData from '../../../data/musikusergroups.json'
import socialUserGroupsData from '../../../data/socialUserGroups.json'

const ADDITIONAL_SHARES = 502

// parses text content from google sheet
// yarn fetchtextcontent fetches text into ../../../data/phoneusergroups.json
// change gsheet ID in packages.json
const parseUserGroups = json => {
  return json.data.map(el => {
    return {
      from: el.from,
      to: el.to,
      highlight: new Date(el.highlight),
      highlight_y: el.highlight_y,
      title: el.title,
      txt: el.txt
    }
  })
}
const internetUserGroups = parseUserGroups(internetUserGroupsData)
const musikUserGroups = parseUserGroups(musikUserGroupsData)
const telefonieUserGroups = parseUserGroups(telefonieUserGroupsData)
const festnetzUserGroups = parseUserGroups(festnetzUserGroupsData)
const socialUserGroups = parseUserGroups(socialUserGroupsData)

const isMobile = window.innerWidth < 768

// parses text content from google sheet editor
// yarn fetchtextcontent fetches text into ../../../data/editor.json
// change gsheet ID in packages.json
const parseEditorContent = json => {
  return json.data.reduce((prev, curr) => {
    if (prev[curr.id] == null) {
      prev[curr.id] = curr.txt != null ? curr.txt : 'Text fehlt'
    } else {
      console.warn('TRYING TO OVERRIDE VALUE', curr.id, curr.txt)
    }
    return prev
  }, {})
}

// component to display editor content (via dangerouslySetInnHTML)
// takes html tag name and editor ID
const Edited = (function() {
  const editorContent = parseEditorContent(editorContentData)

  return ({ tag = 'span', id, ...props }) => {
    return React.createElement(tag, {
      ...props,
      dangerouslySetInnerHTML: { __html: editorContent[id] }
    })
  }
})()

const ARTICLE_ID = '10097773'

// get data from usergroup to generate personalized feedback
const getPersonalizedFeedback = (array, birthYear) => {
  return array.filter(val => {
    return birthYear >= val.from && birthYear <= val.to
  })
}

// component that displays a message based on birth year and user group
export const PersonalizedMessage = ({ birthYear, userGroups }) => {
  // consoleconsole.log('birthYear: ', birthYear)
  // console.log('userGroups: ', userGroups)
  const personalizedFeedback = getPersonalizedFeedback(userGroups, birthYear)
  if (personalizedFeedback.length > 0) {
    const highlightYear = personalizedFeedback[0].highlight.getFullYear()
    const age = highlightYear - birthYear
    /*
    const title =
      age >= 1
        ? `Im Jahr ${highlightYear} waren Sie ${age} Jahre alt`
        : age === 0
          ? `Im Jahr ${highlightYear} wurden Sie geboren`
          : `Im Jahr ${highlightYear} waren Sie noch nicht geboren.`
    */
    let rawText = personalizedFeedback[0].txt
    let personalizedText = '...'
    let audioFile = ''

    /* CHECK FOR USER AGE PLACEHOLDERS */
    if (rawText) {
      let splittedText = rawText.split('[AGE#')
      if (splittedText.length > 1) {
        // console.log('%%%% splittedText %%%%% ' + splittedText)
        for (let i = 0; i < splittedText.length; i++) {
          let agedText = splittedText[i].split('#]')
          if (agedText.length > 1) {
            let targetYear = agedText[0]
            // console.log('%%%% targetYear %%%%% ' + targetYear)
            let targetAge = targetYear - birthYear
            // console.log('%%%% targetAge %%%%% ' + targetAge)
            splittedText[i] = targetAge + agedText[1]
          }
          // console.log('%%%% splittedText[i] %%%%% ' + splittedText[i])
        }
        rawText = splittedText.join('')
      }

      personalizedText = rawText.split('[AGE]').join(age)

      /* CHECK FOR AUDIO PLACEHOLDERS -> VERY BAD SOLUTION.... */
      splittedText = personalizedText.split('[AUDIO*')
      if (splittedText.length > 1) {
        // console.log('%%%% splittedText %%%%% ' + splittedText)
        for (let i = 0; i < splittedText.length; i++) {
          let audioText = splittedText[i].split('*]')
          if (audioText.length > 1) {
            let targetAudio = audioText[0]
            // console.log('%%%% targetAudio %%%%% ' + targetAudio)
            audioFile = require('./audio/' + targetAudio)
            splittedText[i] = audioText[1]
          }
          // console.log('%%%% splittedText[i] %%%%% ' + splittedText[i])
        }
        personalizedText = splittedText
      }
    }
    return (
      <div className='ui message personalized'>
        <div className='avatar'>
          <img src={require('./img/you.svg')} className='ui tiny image' />
          <div className='age-indicator'>{birthYear}</div>
        </div>
        <div className='content'>
          {personalizedText.length === 2 && renderHTML(personalizedText[0])}
          {personalizedText.length === 2 && (
            <AudioPlayer source={audioFile} audioTitle='so tönts' />
          )}
          {personalizedText.length === 2 && renderHTML(personalizedText[1])}
          {personalizedText.length > 2 && renderHTML(personalizedText)}
        </div>
      </div>
    )
  } else {
    return <p>ERROR: unable to generate personalized feedback...</p>
  }
}

class AppComponent extends React.Component<Props, State> {
  state = {
    userBirthYear: null,
    isLoading: false,
    publicationDate: 1,
    sliderValue: 1970,
    isIE11: !!window.MSInputMethodContext && !!document.documentMode
  }

  setBirthYear = birthYear => {
    this.setState({
      userBirthYear: birthYear
    })
  }

  setLoading = () => {
    this.setState({ isLoading: true })
  }

  unsetLoading = () => {
    this.setState({ isLoading: false })
  }

  render() {
    return (
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} additionalShares={ADDITIONAL_SHARES} />
        <ThemeSwitch />

        <header className='ui vertical segment'>
          <div className='ui container'>
            <h1 className='ui header'>
              {!this.state.isIE11 && (
                <Typist
                  stdTypingDelay={20} // blink ist done in CSS
                >
                  <Typist.Delay ms={1900} />
                  Mit welchen Technologien sind wir
                  <Typist.Backspace count={4} delay={1000} />
                  <Typist.Delay ms={500} /> Sie aufgewachsen?
                </Typist>
              )}
              {this.state.isIE11 &&
                'In welcher Tech-Welt sind Sie aufgewachsen?'}
            </h1>

            <h2 className='ui header'>
              <div className='small sub header'>
                Reisen Sie mit: Eine personalisierbare Technik-Zeitreise durch
                die letzten Jahrzehnte.
              </div>
            </h2>
          </div>
        </header>
        <main
          className={`ui vertical infographic segment ${
            this.state.isLoading ? 'loading' : ''
          }`}
          id='main-content'
        >
          <div className='ui text container'>
            <div className='year-chooser'>
              <img
                src={require('./img/you.svg')}
                className='ui tiny image'
                style={{ margin: '0 auto' }}
              />
              {this.state.userBirthYear === null && (
                <Edited tag='h4' id='title1' />
              )}
              <div className='year-display'>{this.state.sliderValue}</div>
              <Nouislider
                range={{ min: 1930, max: 2012 }}
                start={[1970]}
                connect
                onSlide={value =>
                  this.setState({ sliderValue: Math.round(value) })
                }
                onEnd={value => this.setBirthYear(Math.round(value))}
              />
              {this.state.userBirthYear != null && (
                <div className='scroll-hint'>
                  <p style={{ textAlign: 'center' }}>
                    Bitte scrollen
                    <br />
                    <i
                      className={
                        isMobile
                          ? 'icon angle down big'
                          : 'icon angle down huge'
                      }
                    />
                  </p>
                </div>
              )}
            </div>
          </div>

          {this.state.userBirthYear != null && (
            <section className='dark'>
              <SectionTitle
                title='Wie wir telefonieren'
                lead='1993 waren Mobiltelefone auf der Strasse noch ein Hingucker, nur sieben Jahre später besass bereits die Mehrheit der Schweizerinnen und Schweizer ein Gerät.'
                poster={require('./vid/telefonieren-poster.jpg')}
                mp4={require('./vid/telefonieren.mp4')}
                mp4Mobile={require('./vid/telefonieren-mobile.mp4')}
                webm={require('./vid/telefonieren.webm')}
                webmMobile={require('./vid/telefonieren-mobile.webm')}
                originals='https://www.youtube.com/playlist?list=PLjEnTl3TA2mMbTrZqcB9mOdr9NdPU_IhS'
                silent
              />

              <div className='ui chart container'>
                <ChartTelephones
                  data={require('../../../data/telefonie.json')}
                  title={'Das Handy erobert die Schweiz'}
                  subtitle={'Anteil der Bevölkerung in Prozent'}
                  lineColors={{
                    Mobilfunkkunden: '#319cd5',
                    Smartphones: '#E03997'
                  }}
                  userGroups={getPersonalizedFeedback(
                    telefonieUserGroups,
                    this.state.userBirthYear
                  )}
                />
                <PersonalizedMessage
                  birthYear={this.state.userBirthYear}
                  userGroups={telefonieUserGroups}
                />
              </div>

              <div className='ui chart container'>
                <ChartTelephoneconnections
                  data={require('../../../data/telefonanschluesse.json')}
                  title={'Telefonkabinen verschwinden'}
                  subtitle={
                    'Anzahl Publifone (Fernsprechstellen mit Vorauszahlung) in der Schweiz'
                  }
                  lineColors={{
                    Publifon: '#319cd5',
                    Festnetz: '#FFCA18',
                    Glasfaser: '#E03997'
                  }}
                  userGroups={getPersonalizedFeedback(
                    festnetzUserGroups,
                    this.state.userBirthYear
                  )}
                />
                <PersonalizedMessage
                  birthYear={this.state.userBirthYear}
                  userGroups={festnetzUserGroups}
                />
              </div>

              <Waypoint
                onEnter={event => {
                  if (
                    event.previousPosition === Waypoint.below &&
                    event.currentPosition === Waypoint.inside
                  ) {
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                      event: 'Interactions',
                      event_action: 'vertical-scroll',
                      event_label: '25ContentRead'
                    })
                  }
                }}
              />
            </section>
          )}

          {this.state.userBirthYear != null && (
            <section>
              <SectionTitle
                title='Wie wir<br />online gehen'
                lead='Nachdem das Internet gut zwanzig Jahre lang Universitäten und Forschungseinrichtungen vernetzte, war es ab 1990 öffentlich zugänglich. Danach dauerte es noch gut zehn Jahre und die Schweiz war online.'
                poster={require('./vid/internet-poster.jpg')}
                mp4={require('./vid/internet.mp4')}
                mp4Mobile={require('./vid/internet-mobile.mp4')}
                webm={require('./vid/internet.webm')}
                webmMobile={require('./vid/internet-mobile.webm')}
                originals='https://www.youtube.com/playlist?list=PLjEnTl3TA2mNEjkAJHQZ3Cj1L_F-908rs'
                silent={false}
              />

              <div className='ui chart container'>
                <ChartInternet
                  data={require('../../../data/internet.json')}
                  title={'Wie sich das Internet in der Schweiz ausbreitete'}
                  subtitle={'Anteil der Bevölkerung ab 14 Jahren in Prozent'}
                  lineColors={{
                    'Internetnutzung mehrmals pro Woche': '#319cd5',
                    'mobiler Zugang': '#E03997'
                  }}
                  userGroups={getPersonalizedFeedback(
                    internetUserGroups,
                    this.state.userBirthYear
                  )}
                />
                <PersonalizedMessage
                  birthYear={this.state.userBirthYear}
                  userGroups={internetUserGroups}
                />
              </div>

              <div className='ui chart container'>
                <ChartDownloadspeed
                  data={require('../../../data/internetanschluesse.json')}
                  title={'Wie Schweizer Haushalte vernetzt sind'}
                  subtitle={
                    'Anteil Internetnutzer nach Anschlussart, in Prozent des Totals'
                  }
                  lineColors={{
                    'schnelle Verbindung': '#E03997',
                    'mittlere Verbindung': '#FFCA18',
                    'langsame Verbindung': '#319cd5'
                  }}
                  userGroups={getPersonalizedFeedback(
                    internetUserGroups,
                    this.state.userBirthYear
                  )}
                />
              </div>

              <Waypoint
                onEnter={event => {
                  if (
                    event.previousPosition === Waypoint.below &&
                    event.currentPosition === Waypoint.inside
                  ) {
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                      event: 'Interactions',
                      event_action: 'vertical-scroll',
                      event_label: '50ContentRead'
                    })
                  }
                }}
              />

              <div className='ui text container'>
                <DownloadComparison
                  title='Downloadgeschwindigkeiten im Vergleich'
                  subtitle='Herunterladen eines 800 MB Spielfilms, bei Idealbedingungen'
                  source='Swisscom, eigene Recherche'
                />
              </div>
            </section>
          )}

          {this.state.userBirthYear != null && (
            <section className='dark'>
              <SectionTitle
                title='Wie wir<br />Musik hören'
                lead='Der physische Tonträger ist praktisch tot. 2000 gingen in der Schweiz noch 19,6 Millionen CDs über den Ladentisch, heute sind es noch 2,75 Millionen. Dass Schallplatten seit 2014 ein kleines Revival erleben, hebt die Laune der Musikbranche nicht.'
                poster={require('./vid/musik-poster.jpg')}
                mp4={require('./vid/musik.mp4')}
                mp4Mobile={require('./vid/musik-mobile.mp4')}
                webm={require('./vid/musik.webm')}
                webmMobile={require('./vid/musik-mobile.webm')}
                originals='https://www.youtube.com/playlist?list=PLjEnTl3TA2mOFYTeUvFvI72g1MCFmnXhn'
                silent
              />

              <div className='ui chart container'>
                <ChartMusic
                  data={require('../../../data/musikmarkt.json')}
                  title={'Wie Schweizer Musik hören'}
                  subtitle={'Verkaufte Einheiten in Millionen'}
                  lineColors={{
                    CD: '#E03997',
                    MC: '#FFCA18',
                    LP: '#319cd5'
                  }}
                  userGroups={getPersonalizedFeedback(
                    musikUserGroups,
                    this.state.userBirthYear
                  )}
                />
                <PersonalizedMessage
                  birthYear={this.state.userBirthYear}
                  userGroups={musikUserGroups}
                />
              </div>

              <Waypoint
                onEnter={event => {
                  if (
                    event.previousPosition === Waypoint.below &&
                    event.currentPosition === Waypoint.inside
                  ) {
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                      event: 'Interactions',
                      event_action: 'vertical-scroll',
                      event_label: '75ContentRead'
                    })
                  }
                }}
              />

              <div className='ui chart container'>
                <ChartStreaming
                  data={require('../../../data/streaming.json')}
                  title={'Streaming als schwacher Trost'}
                  subtitle={
                    'Umsatz Musikverkäufe in der Schweiz in Millionen Franken'
                  }
                  lineColors={{
                    Physisch: '#319cd5',
                    Downloads: '#FFCA18',
                    Streaming: '#E03997'
                  }}
                  userGroups={getPersonalizedFeedback(
                    internetUserGroups,
                    this.state.userBirthYear
                  )}
                />
              </div>

              <div className='ui chart container'>
                <StorageEvolution
                  title='Die Entwicklung von Datenträgern'
                  subtitle='Speicherkapazität zu ausgewählten Zeitpunkten'
                  source='Eigene Recherche'
                />
              </div>
            </section>
          )}

          {this.state.userBirthYear != null && (
            <section>
              <SectionTitle
                title='Wie wir unser<br />Sozialleben gestalten'
                lead='Die Macht sozialer Netzwerke dürfte inzwischen allen bewusst sein. Bemerkenswert ist vor allem, wie rasend die Entwicklung war.'
                poster={require('./vid/socialmedia-poster.jpg')}
                mp4={require('./vid/socialmedia.mp4')}
                mp4Mobile={require('./vid/socialmedia-mobile.mp4')}
                webm={require('./vid/socialmedia.webm')}
                webmMobile={require('./vid/socialmedia-mobile.webm')}
                originals='https://www.srf.ch/sendungen/einstein/droge-smartphone-wie-abhaengig-sind-wir'
                silent
              />

              <div className='ui chart container'>
                <ChartSocialnetworks
                  data={require('../../../data/socialnetworks.json')}
                  title={'Soziale Netzwerke'}
                  subtitle={'Monatlich aktive Nutzer weltweit, in Millionen'}
                  lineColors={{
                    Instagram: '#E03997',
                    Whatsapp: '#54AF71',
                    Twitter: '#00A1CA',
                    Facebook: '#1D5F82'
                  }}
                  userGroups={getPersonalizedFeedback(
                    socialUserGroups,
                    this.state.userBirthYear
                  )}
                />
                <PersonalizedMessage
                  birthYear={this.state.userBirthYear}
                  userGroups={socialUserGroups}
                />
              </div>
            </section>
          )}
        </main>

        {this.state.userBirthYear != null && (
          <Footer
            articleId={ARTICLE_ID}
            additionalShares={ADDITIONAL_SHARES}
            hidePortfolioTeaser
            invertedBottom
            starColor='#a8945e'
            questions={[
              'Wie informativ war der Beitrag?',
              'Wie gefallen Ihnen die personalisierten Texte?',
              'Wie finden Sie die Gestaltung?'
            ]}
            credits={[
              [
                'Konzept und Programmierung',
                'Mathias Lutz und Marc Brupbacher'
              ],
              [
                'Texte',
                `Amir Mustedanagic, Marc Brupbacher, Sebastian Broschinski, Rafael Zeier, Mathias Lutz`
              ],
              [
                'Inspiration',
                '<a href="https://www.washingtonpost.com/graphics/2017/entertainment/tech-generations/?utm_term=.c63a95834042">What tech world did you grow up in?</a>'
              ]
            ]}
          />
        )}

        {this.state.userBirthYear === null && (
          <section>
            <div className='ui text container' style={{ textAlign: 'center' }}>
              <i className='icon angle up' />
              <p className='input-hint'>Bitte geben Sie Ihr Geburtsjahr ein.</p>
              <p className='spacer'>&nbsp;</p>
            </div>
          </section>
        )}
      </div>
    )
  }
}

export default hot(module)(AppComponent)
